import { Model } from 'pinia-orm';
import Application from './Application';
import Contact from "./Contact";
import InboundEmail from "./InboundEmail";
import OutboundEmail from "./OutboundEmail";
import Invitation from "./Invitation";
import Confirmation from "./Confirmation";

export default class Document extends Model {
    static get entity() {
        return 'documents';
    }

    static fields() {
        return {
            id: this.uid(),
            application_id: this.attr(null),
            name: this.attr(null),
            filename: this.attr(''),
            original_name: this.attr(''),
            officient_id: this.attr(''),
            extension: this.attr(''),
            description: this.attr({}),
            document_url: this.attr(''),
            application: this.belongsTo(Application, 'application_id'),
            scanned_at: this.attr(null),
            safe: this.attr(null),
            attachable_id: this.attr(null),
            attachable_type: this.attr(null),
            attachable: this.morphTo(
                [Application, Contact, InboundEmail, OutboundEmail, Invitation, Confirmation],
                'attachable_id',
                'attachable_type'
            ),
            created_at: this.attr(null)
        }
    }

    async toFile() {
        let response = await fetch(this.document_url);
        let data = await response.blob();
        let file = new File([data], this.original_name);
        file.id = this.id;
        return file;
    }
}
